import { Logo } from "../assets";

export default function Navbar() {
  return (
    <section className="w-full fixed top-5 left-0 right-0 z-40 px-4 md:px-10">
      <nav className="bg-black text-white flex items-center justify-between pl-4 pr-4 lg:pr-0 lg:pl-14 rounded-full py-4 w-full">
        <Logo />

        <div className="flex items-center justify-between pr-0 md:pr-4">
          <div className="hidden lg:flex items-center lg:gap-8 pr-4">
            <a href="#about" className="text-base regular-font">
              About
            </a>
            <a href="#how-it-works" className="text-base regular-font">
              How it works
            </a>
            <a href="#features" className="text-base regular-font">
              Features
            </a>
            <a href="#faq" className="text-base regular-font">
              Faq
            </a>
          </div>
          <a
            href="https://app.buymejollof.com/login"
            target="_blank"
            rel="noreferrer"
            className="bg-mainYellow text-sm md:text-base text-mainAsh px-5 py-2 md:py-4 flex justify-center items-center rounded-3xl bold-font"
          >
            Join as a creator
          </a>
        </div>
      </nav>
    </section>
  );
}
